module.exports = __webpack_public_path__ + "img/signs13.e8df3587.jpg";